export class AuthorizationFlowConstants {
  public static readonly PasswordExpired = 'PasswordExpired';
  public static readonly SessionExpiration = 'SessionExpiration';
  public static readonly PasswordChangeRequired = 'PasswordChangeRequired';
  public static readonly ValidationOtpRequired = 'two_factor_authentication_required';
  public static readonly ValidationOtpInvalid = 'two_factor_authentication_invalid';
  public static readonly ValidationOtpNotSent = 'two_factor_authentication_send_code_failed';
  public static readonly CustomerVerificationInProgress = 'customer_verification_in_progress';

  public static readonly ExpiredPasswordStatuses = [
    AuthorizationFlowConstants.PasswordExpired,
    AuthorizationFlowConstants.PasswordChangeRequired
  ];
}
